import { useQuery } from '@tanstack/react-query'
import { postNamedQuery } from '../../../../../service'

export const useListInfographicBlocks = (body = {}, options = {}) => {
  const { mapper = null, enabled = true } = options ?? {}
  return useQuery({
    queryKey: ['reports', 'listInfographicBlocks', body],
    queryFn: async () => {
      const { data } = await postNamedQuery('reports', 'list-infographic-blocks', body)
      return data
    },
    enabled,
    mapper: mapper ?? ((data) => data?.data ?? [])
  })
}
